import React from 'react'
import LabeledPrice from '../../../common/form-components/labeled-inputs/LabeledPrice'
import { FUELS } from '../../../../utils/constants/fuels'
import './fuelsPrices.scss'

const FuelsPrices = ({ prices, isReadOnly, onChange }) => {
  const disabled = isReadOnly ?? false

  return (
    <div className="fuels-prices">
      <form>
        <div className="fuels-wrapper-flex">
          <LabeledPrice
            classNameBox="flex-container-fuels-price"
            idLabel={FUELS.GOA}
            required
            name={FUELS.GOA}
            value={prices?.GOA}
            disabled={disabled}
            onChange={onChange}
          />
          <LabeledPrice
            classNameBox="flex-container-fuels-price"
            idLabel={FUELS.GOAPLUS}
            name={FUELS.GOAPLUS}
            value={prices?.GOAPLUS}
            disabled={disabled}
            onChange={onChange}
          />
          <LabeledPrice
            classNameBox="flex-container-fuels-price"
            idLabel={FUELS.G95}
            required
            name={FUELS.G95}
            value={prices?.G95}
            disabled={disabled}
            onChange={onChange}
          />
          <LabeledPrice
            classNameBox="flex-container-fuels-price"
            idLabel={FUELS.ADBLUE}
            name={FUELS.ADBLUE}
            value={prices?.AdBlue}
            disabled={disabled}
            onChange={onChange}
          />
        </div>
      </form>
    </div>
  )
}

export default FuelsPrices
